<template>
  <!--
    	作者：wangxw
    	时间：2019-11-05
    	描述：diy组件 搜索栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--上下边距-->
      <el-form-item label="上下边距："><el-slider v-model="curItem.style.paddingTop" show-input></el-slider></el-form-item>
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>
      <!--文字颜色-->
      <el-form-item label="文字颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.textColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>
      <!--公告图标-->
      <el-form-item label="公告图标：">
        <div class="diy-notice-icon">
          <img v-img-url="curItem.params.icon" alt="" @click="$parent.onEditorSelectImage(curItem.params, 'icon')">
        </div>
        <div>建议尺寸32×32</div>
      </el-form-item>
      <!-- 公告内容 -->
      <!-- <el-form-item label="公告内容：">
        <el-input v-model="curItem.params.text" class="w-auto"></el-input>
      </el-form-item> -->
      <el-form-item label="公告记录" >
        <el-button size="small" type="primary" @click="addOrder" >新增公告</el-button>
        <el-table :data="curItem.params.order"  border size="mini" style="width: 100%;margin-top: 20px;">

          <el-table-column prop="name" label="排序"    width="100" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="name" label="公告记录"   >
              <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="textarea" v-model="scope.row.context"  placeholder="请输入公告记录"></el-input>
                 
                  </div>
                </div>
    
              </template>
            </el-table-column>     


  
            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delOrder(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item> 
    </el-form>
  </div>
</template>

<script>
import { create } from 'lodash';

  export default {
    data() {
      return {

      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {
      if(! this.curItem.params.order){
        this.curItem.params.order = [];
          }
    },
    methods: {
      delOrder(index){
        this.curItem.params.order.splice(index,1)
    },
      addOrder(){
        this.curItem.params.order.push({
          "code":this.randomString(8,this.randomString(6,0)),
          "sort":50,
          "name":"",
        });
      },
    }
  };
</script>

<style>
.diy-notice-icon, .diy-notice-icon img{ width: 32px; height: 32px;}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Notice.vue